import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import GradientMesh from './GradientMesh';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.12, delayChildren: 0.05 },
  },
};

const itemVariants = {
  hidden: { y: 24, opacity: 0 },
  visible: { y: 0, opacity: 1, transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] } },
};

const CTA = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.15 });

  return (
    <section
      id="contact"
      ref={ref}
      className="relative overflow-hidden"
      style={{
        paddingTop: 'clamp(4rem, 10vh, 7rem)',
        paddingBottom: 'clamp(4rem, 10vh, 7rem)',
        background: 'linear-gradient(135deg, #0F172A 0%, #1E1B4B 60%, #312E81 100%)',
        color: '#FFFFFF',
      }}
    >
      <GradientMesh variant="dark" />

      <div className="container relative">
        <motion.div
          className="flex flex-col items-center text-center"
          style={{ maxWidth: '720px', margin: '0 auto' }}
          variants={containerVariants}
          initial="hidden"
          animate={inView ? 'visible' : 'hidden'}
        >
          <motion.h2
            variants={itemVariants}
            style={{
              fontSize: 'clamp(2rem, 5vw, 3.5rem)',
              fontWeight: 700,
              lineHeight: 1.1,
              letterSpacing: '-0.03em',
              color: '#FFFFFF',
              marginBottom: 'var(--spacing-lg)',
            }}
          >
            Building something that should exist?
          </motion.h2>

          <motion.p
            variants={itemVariants}
            style={{
              fontSize: 'clamp(1rem, 1.6vw, 1.2rem)',
              lineHeight: 1.55,
              color: 'rgba(255, 255, 255, 0.75)',
              maxWidth: '560px',
              marginBottom: 'var(--spacing-2xl)',
            }}
          >
            Tell us what you&rsquo;re working on. We&rsquo;ll tell you whether AI is the
            right tool — and if so, how to ship it.
          </motion.p>

          <motion.div variants={itemVariants} className="flex items-center gap-md flex-wrap justify-center">
            <motion.a
              href="/discover"
              whileHover={{ y: -2 }}
              whileTap={{ scale: 0.98 }}
              transition={{ type: 'spring', stiffness: 400, damping: 25 }}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                padding: 'var(--spacing-lg) var(--spacing-2xl)',
                borderRadius: 'var(--radius-lg)',
                background: '#FFFFFF',
                color: '#0F172A',
                fontWeight: 600,
                fontSize: 'var(--text-lg)',
                boxShadow: '0 12px 28px -10px rgba(0,0,0,0.45)',
              }}
            >
              Start building
              <span style={{ marginLeft: '0.6rem' }}>→</span>
            </motion.a>

            <motion.a
              href="mailto:hello@z37.io"
              whileHover={{ y: -2 }}
              whileTap={{ scale: 0.98 }}
              transition={{ type: 'spring', stiffness: 400, damping: 25 }}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                padding: 'var(--spacing-lg) var(--spacing-2xl)',
                borderRadius: 'var(--radius-lg)',
                border: '1px solid rgba(255,255,255,0.25)',
                color: '#FFFFFF',
                fontWeight: 600,
                fontSize: 'var(--text-lg)',
              }}
            >
              hello@z37.io
              <span style={{ marginLeft: '0.6rem' }}>→</span>
            </motion.a>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTA;
